export const handleHtmlExtraction = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const htmlContent = e.target.result;
      const parsedData = parseTableToCSV(htmlContent);
      resolve(parsedData);
    };
    reader.onerror = reject;
    reader.readAsText(file);
  });
};

const parseTableToCSV = (htmlContent) => {
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(htmlContent, "text/html");
  const table = htmlDoc.querySelector("table");

  if (!table) {
    console.error("Table not found in HTML content");
    return [];
  }

  const rows = table.querySelectorAll("tr");
  const parsedData = [];

  rows.forEach((row, rowIndex) => {
    if (rowIndex === 0) return; // Skip the header row

    const cells = row.querySelectorAll("td");
    if (cells.length === 0) return; // Skip empty rows

    const cellsArray = Array.from(cells);
    if (cellsArray.length === 10) {
      cellsArray.splice(1, 1); // Remove the second column (index 1)
    }

    const rowData = {
      Id: '',
      Balance: '',
      Amount: '',
      Currency: 'GBP',
      Type: 'TRADE',
      Status: 'PROCESSED',
      Modified: '',
      'Trade Id': '',
      'Instrument Symbol': '',
      'Instrument Name': '',
      Commission: '',
      'Account type': 'T212'
    };

    cellsArray.forEach((cell, cellIndex) => {
      let content = cell.textContent.replace(/\s+/g, " ").trim();

      // console.log('content', content)
      // content POS13755378167
      // content Buy
      // content 95
      // content PYPL
      // content 68.25
      // content 2024.04.30 21:11
      // content MO13755380172
      // content 68.19
      // content -4.58

      // Map data to the correct fields
      switch (cellIndex) {
        case 0: 
          rowData.Id = content;
          rowData['Trade Id'] = content;
          break;
        case 1: // Balance
          rowData.Balance = '';
          break;
        case 8: // Amount
          rowData.Amount = content;
          break;
        case 3: // Instrument
          rowData['Instrument Symbol'] = content;
          rowData['Instrument Name'] = content;
          break;
        case 5: // Date
          rowData.Modified = content;
          break;
        case 7: // Commission
          rowData.Commission = "";
          break;
      }
    });

    // Only add the row if it has important data
    if (rowData.Id || rowData.Amount || rowData['Instrument Symbol']) {
      parsedData.push(rowData);
    }
  });

  return parsedData;
};